<div class="notification-panel" *ngIf="showNotification" (click)="onPanelClick($event)">
  <div class="notification-content">
    <span class="notification-header-text">Notifications</span>
    <span class="notification-count">{{notificationCount}} New</span>
  </div>
  
  <div class="notification-list">
    <div class="notification-empty-state" *ngIf="notifications.length === 0">
      <div class="empty-state-icon">
        <img src="../../../../assets/images/aesthetics/bell.svg" alt="No Notifications" style="width: 48px; height: 48px; opacity: 0.3;" />
      </div>
      <div class="empty-state-text">No new triggered alerts</div>
    </div>

    <div class="notification-item"
     *ngFor="let notification of notifications"
     (click)="onNotificationClick(notification, $event)">
      
  <div class="notification-icon-wrapper">
    <input 
      type="checkbox"
      class="notification-checkbox"
      [(ngModel)]="notification.checked"
    />
  </div>

  <div class="notification-details">
    <div class="notification-header">{{ notification.header }}</div>
    <div class="notification-text"
   
         [innerHTML]="getSanitizedHtml(notification.text)"
         [attr.title]="stripHtml(notification.text)">
    </div>
  </div>
</div>

  </div>
  
<!-- <div class="notification-footer" >
    <button class="clear-all-btn" (click)="onClearAll()">Clear All</button>
  </div> -->
  <div class="notification-footer" *ngIf="showClearAll && notifications.length > 0">
  <button 
    class="clear-all-btn" 
    (click)="onClearAll()" 
    [disabled]="!hasCheckedNotifications()">
    Clear All
  </button>
</div>

</div>